/**
 * What every brand shares: the product's navigation, its feature switches and
 * the sample account the demo surfaces fall back to. A brand pack spreads this
 * and supplies the rest — who the company is, how it looks, what the document
 * carries — plus any wording of its own.
 */
export const baseBrandConfig = {
    user: {
        name: 'William Lee',
        firstName: 'William',
        lastName: 'Lee',
        company: 'No Limit Assistance',
        email: 'wlee17@gmail.com',
        phone: '3234486402',
        customerNumber: '0210453',
    },
    illustrations: {
        recentCases: null,
        orders: null,
        noResults: null,
        hero: null,
    },
    navigation: {
        main: [
            { id: 'dashboard', label: 'Dashboard' },
            { id: 'drafts', label: 'Drafts' },
            { id: 'orders', label: 'Orders' },
            { id: 'cases', label: 'Cases' },
            { id: 'matters', label: 'Matters' },
        ],
        services: [
            { id: 'e-filing', label: 'eFiling', description: 'Electronic court filing with any California court' },
            { id: 'court-filing', label: 'Court Filing', description: 'Physical filing at California courts' },
            { id: 'process-serving', label: 'Process Serving', description: 'Serve legal documents to parties' },
            { id: 'document-retrieval', label: 'Document Retrieval', description: 'Retrieve copies of filed documents' },
            { id: 'courtesy-copy-delivery', label: 'Courtesy Copy Delivery', description: 'Deliver courtesy copies to judges or departments' },
            { id: 'secretary-of-state-filing', label: 'Secretary of State Filing', description: 'File documents with the Secretary of State' },
            { id: 'county-recording', label: 'County Recording', description: 'Record documents with the county recorder' },
            { id: 'skip-trace', label: 'Skip Trace', description: 'Locate individuals for service of process' },
            { id: 'eservice', label: 'eService', description: 'Electronic service of documents to parties' },
        ],
        sidebar: [
            { id: 'placeOrder', label: 'Place New Order', icon: 'Plus', primary: true, action: 'modal' },
            { id: 'dashboard', label: 'Dashboard', icon: 'Dashboard' },
            { id: 'orders', label: 'Orders', icon: 'Briefcase' },
            { id: 'drafts', label: 'Drafts', icon: 'Document' },
            { id: 'pending', label: 'Pending Submission', icon: 'Clock' },
            { id: 'cases', label: 'Cases', icon: 'Folder' },
            { id: 'matters', label: 'Matters', icon: 'Folder' },
            { id: 'attorneys', label: 'Attorneys', icon: 'User' },
            { id: 'settings', label: 'Settings', icon: 'Settings' },
        ],
    },
    footerLinks: {
        accessibility: { label: 'Accessibility', url: '/legal/accessibility' },
        privacy: { label: 'Privacy Policy', url: '/legal/privacy' },
        terms: { label: 'Terms of Service', url: '/legal/terms' },
    },
    features: {
        showChatBubble: true,
        showSupportCenter: true,
        showBlogSection: false,
    },
    text: {
        dashboard: {
            placeOrderTitle: 'Place an order',
            recentCasesTitle: 'Recent cases',
            recentCasesEmpty: "Cases you've recently interacted with will appear here.",
            recentCasesCTA: 'Get started by placing an order or',
            recentCasesLink: 'adding a case to your portfolio',
            ordersTitle: 'Orders',
            ordersEmpty: 'Your recent orders will appear here.',
            orderStatusTitle: 'Order status',
            supportTitle: '24/7 Support Center',
            supportDescription: 'Our team is here to provide expert support with filing, serving, court specific requirements, pricing, and more.',
            // Dashboard stat cards. Exactly one Upcoming Deadlines metric (Walter
            // R27 — the duplicate "Next 60 days" tile is gone) and no Pending
            // Signatures tile (R28 — it carried no context for what it counted).
            // The deadlines30 value here is only the pre-fetch placeholder — the
            // dashboard overrides it with the live count from the same fetch the
            // Upcoming Deadlines panel renders, so the two always agree (R30).
            stats: [
                { id: 'activeFilings', label: 'Active Filings', value: 27, trend: 23 },
                { id: 'rejections', label: 'Recent Rejections', value: 3, subLabel: 'Last 7 days' },
                { id: 'deadlines30', label: 'Upcoming Deadlines', value: 5, subLabel: 'Next 30 days' },
            ],
        },
        login: {
            welcome: 'Welcome to',
            loginTitle: 'Log in to your account',
            rememberMe: 'Remember me',
            forgotPassword: 'Forgot password?',
            needHelp: 'Need help?',
            contactUs: 'Contact us',
            newUser: 'New to',
            createAccount: 'Create an account',
        },
        common: {
            search: 'Search',
            cancel: 'Cancel',
            continue: 'Continue',
            update: 'Update',
            save: 'Save',
            clear: 'Clear',
            loading: 'Loading...',
        },
    },
};
